import { defineMessages } from 'react-intl';

export default defineMessages({
  empty: {
    defaultMessage: 'It\'s rather empty here...',
    id: 'todos.todos.empty'
  }
});



// WEBPACK FOOTER //
// ./src/common/todos/todosMessages.js